import { InputHTMLAttributes, ReactNode } from 'react'
import MultiInput from '../../Generic/Multi/MultiInput'
import './CheckboxInput.less'

export interface CheckboxInputProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> {
  id: string
  label: ReactNode
  labelClassName?: string
}

const CheckboxInput = ({ label, labelClassName, ...props }: CheckboxInputProps) => (
  <MultiInput type={'checkbox'} label={label} labelClassName={labelClassName} {...props} />
)

export default CheckboxInput
